import {
  ContentCarouselDesktopMedia,
  ContentCarouselMobileMedia,
  ContentCarouselHeader,
  ContentCarouselDescription,
  ContentCarouselSlidesText,
  ContentCarouselControls,
} from './ui';
import type { ContentCarouselProps } from './content-carousel.types';
import { useContentCarousel } from './useContentCarousel';

export function ContentCarousel({ block }: ContentCarouselProps) {
  const {
    isActive,
    slides,
    isImageRight,
    backgroundClass,
    emblaRef,
    currentIndex,
    goPrev,
    goNext,
    slideWrapperClass,
    isCurrentVideo,
    resolvedHeadingText,
    hasDescription,
    heading,
    description,
    cn,
  } = useContentCarousel({ block });

  if (!isActive || slides?.length === 0) return null;

  return (
    <div
      className={cn('content-carousel-bg relative w-full overflow-hidden', backgroundClass)}
      id={block.sectionAnchorId?.current || undefined}
    >
      <div className="content-carousel-container md:p-30 px-6 py-12 porta-container">
        <div
          className={cn(
            'content-carousel-wrapper w-full flex flex-col md:flex-row items-center justify-center transition-all duration-700 ease-in-out',
            isCurrentVideo ? 'md:gap-3xl' : 'md:gap-full-banner',
          )}
        >
          {/* --- Media Section (Desktop) --- */}
          <ContentCarouselDesktopMedia
            slides={slides ?? []}
            currentIndex={currentIndex}
            isImageRight={!!isImageRight}
            isCurrentVideo={!!isCurrentVideo}
            slideWrapperClass={slideWrapperClass}
          />

          {/* --- Text Section --- */}
          <div
            className={cn(
              'relative overflow-hidden flex flex-col flex-1 w-full ',
              isImageRight ? 'md:order-1' : 'order-3',
              isCurrentVideo ? 'md:h-110' : 'md:h-136',
            )}
          >
            <div className={cn('heading-container flex flex-col justify-between h-full')}>
              <div className="flex flex-col">
                <ContentCarouselHeader heading={heading} resolvedHeadingText={resolvedHeadingText} />

                <ContentCarouselDescription hasDescription={hasDescription} description={description} />

                <ContentCarouselSlidesText
                  slides={slides ?? []}
                  emblaRef={emblaRef}
                  isCurrentVideo={!!isCurrentVideo}
                />
              </div>

              <ContentCarouselControls slidesLength={slides?.length ?? 0} onPrev={goPrev} onNext={goNext} />
            </div>

            {/* --- Media Section (Mobile) --- */}
            <ContentCarouselMobileMedia
              slides={slides ?? []}
              currentIndex={currentIndex}
              isImageRight={!!isImageRight}
              slideWrapperClass={slideWrapperClass}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
